export default "__VITE_ASSET__B2wPxTvK__"